<template>
  <el-form :inline="true">
    <el-col :span="24">
      <el-form-item :label="tips">
        <el-button @click="handleClick" type="primary" v-if="leftTime <= 0" size="mini">获取验证码</el-button>
        <el-button disabled type="primary" v-if="leftTime>0" size="mini">{{leftTime}} 秒</el-button>
      </el-form-item>
    </el-col>
    <el-col :span="24" v-if="mobileNo">
      <el-form-item label="手机号码：">
        <el-input v-model="mobileNo"></el-input>
      </el-form-item>
    </el-col>
    <el-col :span="24">
      <el-form-item label="短信验证码：">
        <el-input v-model="code"></el-input>
      </el-form-item>
    </el-col>
  </el-form>
</template>

<script>
  let timeTtl = 60

  export default {
    name: "SmsCode",
    data() {
      return {
        leftTime: 0
      }
    },
    props: {
      tips: {
        type: String,
        default: '系统会给手机发送动态验证码'
      },
      mobileNo: {
        type: String,
        default: ''
      },
      value: {
        type: String,
        default: ''
      },
      params: {
        type: Object,
        default: ()=> {
          return {

          }
        }
      },
      api: {
        type: Function
      }
    },
    computed: {
      code: {
        get() {
          return this.value
        },
        set(newVal) {
          this.$emit('input', newVal)
        }
      }
    },
    methods: {
      handleClick: function () {
        this.sendCode().then((res) => {
          if( res.status == 'success') {
            this.leftTime = timeTtl

            let timer = setInterval(()=> {
              this.leftTime --
              if(this.leftTime <= 0) {
                clearInterval(timer)
              }
            }, 1000)
          }
          else {
            this.$message.error('短信验证码发送失败！')
          }
        })
          .catch(error => {

          })
      },
      sendCode: function () {
        return new Promise((resolve, reject) => {
          if(typeof this.api == 'function') {
            this.api.apply(null, [this.params, res=> {
              return resolve(res.data||{})
            }])
          }
          else {
            return reject()
          }
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/SmsCode.vue